import { render, staticRenderFns } from "./AiCard.vue?vue&type=template&id=6c23af6c&scoped=true&"
import script from "./AiCard.vue?vue&type=script&lang=js&"
export * from "./AiCard.vue?vue&type=script&lang=js&"
import style0 from "./cards.css?vue&type=style&index=0&id=6c23af6c&scoped=true&lang=css&"
import style1 from "./AiCard.vue?vue&type=style&index=1&id=6c23af6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23af6c",
  null
  
)

export default component.exports